var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleLatency, handleErrors, handleTamper, handleOffline } from '../handlers';
let config = { enabled: false };
self.addEventListener('message', (event) => {
    const message = event.data;
    switch (message.type) {
        case 'CONFIGURE':
            config = message.payload;
            break;
        case 'UPDATE_CONFIG':
            config = Object.assign(Object.assign({}, config), message.payload);
            break;
        default:
            console.warn('Unknown message type');
    }
});
self.addEventListener('fetch', (event) => {
    event.respondWith((() => __awaiter(void 0, void 0, void 0, function* () {
        let response = yield fetch(event.request);
        const offlineResponse = yield handleOffline(config.offline);
        if (offlineResponse)
            return offlineResponse;
        // Apply other handlers in sequence
        response = yield handleLatency(response, config.latency);
        response = yield handleErrors(response, event.request, config.errors);
        response = handleTamper(response, config.tamper);
        return response;
    }))());
});
